import { render, staticRenderFns } from "./MessageQueueAdmin.vue?vue&type=template&id=b3bf8726"
import script from "./MessageQueueAdmin.vue?vue&type=script&lang=js"
export * from "./MessageQueueAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports